import { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import ContactInner from "../components/ContactInner";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import FooterThree from "../components/FooterThree";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import { useLocation } from "react-router-dom";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const ContactPage = () => {
  const { setLoading } = useLoader();
  const { companyDetailsData, setCompanyDetailsData } = useCompanyDetailsContext();
  // const [contactHeaderData, setContactHeaderData] = useState([]);
  // const [contactFormHeaderData, setContactFormHeaderData] = useState([]);
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.state]);
  const contactHeaderData = allData.contactHeaderData;
  const contactFormHeaderData = allData.contactHeaderData;
  const contactBannerData = allData.allBannerData[0]?.contact_title;
  // useEffect(() => {
  //   setLoading(true);
  //   Promise.all([fetchcontactHeader(),fetchcontactFormHeader()])
  //     .then(([contactHeader,contactFromHeader]) => {
  //       setContactHeaderData(contactHeader);
  //       setContactFormHeaderData(contactFromHeader);
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     })
  //     .catch(() => {
  //       console.error("Server Error");
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 500);
  //     });
  // }, [setLoading]);
  FetchAllApi({ companyDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetailsData]) => {
          setCompanyDetailsData(companyDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={contactBannerData} title={"Contact"} />

      {/* ContactInner */}
      <ContactInner
        contactHeaderData={contactHeaderData}
        contactFormHeaderData={contactFormHeaderData}
      />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default ContactPage;
